import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateTime } from "luxon";
import ShowMembersButton from "./ShowMembersButton";
import EditShiftButton from "./EditShiftButton";
import CopyShiftButton from "./CopyShiftButton";
import {
  addMember,
  clearMemberSelection,
} from "../../stores/member/memberActions";
import ShiftValidator from "./ShiftValidator";
import i18n from "../../utils/i18n";

const hourHeight = 5;

const Shift = (props) => {
  const dispatch = useDispatch();
  const shiftRef = useRef(null);

  const membersById = useSelector((state) => state.member.members_by_id);
  const shifts = useSelector((state) => state.member.shifts);

  useEffect(() => {
    if (props.read_only) return;
    const node = shiftRef.current;
    if (!node) return;
    $(node).droppable({
      hoverClass: "drop-hover",
      tolerance: "pointer",
      drop: function (event, ui) {
        var member_elems = ui.helper.children();
        if (member_elems.length === 0) return;
        if (
          member_elems.length + props.shift.members.length >
          props.shift.attendance_limit
        ) {
          alert(i18n.t("schedule.shifts.too_many_for_this_shift"));
          return;
        }
        var members = Array.from(member_elems).map((member_element) => {
          let dom_member = JSON.parse($(member_element).attr("data-member"));
          return membersById[dom_member.id];
        });
        return ShiftValidator.validate(shifts, members, props.shift)
          .catch((error) =>
            props.canSkipValidation
              ? confirm(
                  `${error}\n${i18n.t(
                    "schedule.shifts.confirm_skip_validation"
                  )}`
                )
              : alert(error)
          )
          .then((confirmed) => {
            if (!confirmed) return;
            members.forEach((member) => handleAddMember(member));
            return dispatch(clearMemberSelection());
          });
      },
    });
    return () => {
      $(node).droppable("destroy");
    };
  });

  const handleAddMember = (member) => {
    var shift = props.shift;
    var exist = shift.members.filter((m) => m.id === member.id);
    if (
      exist.length === 0 &&
      props.shift.members.length < shift.attendance_limit
    ) {
      dispatch(addMember(shift.identifier, member));
    }
  };

  const shiftHeight = () => {
    var shift = props.shift;
    const startTime =
      shift.start_time instanceof DateTime
        ? shift.start_time
        : DateTime.fromISO(shift.start_time);
    const endTime =
      shift.end_time instanceof DateTime
        ? shift.end_time
        : DateTime.fromISO(shift.end_time);
    var duration = endTime.diff(startTime, "minutes").minutes / 60;
    return hourHeight * duration + "rem";
  };

  const shiftTop = () => {
    const startTime =
      props.shift.start_time instanceof DateTime
        ? props.shift.start_time
        : DateTime.fromISO(props.shift.start_time);
    const startOfDay = startTime.startOf("day");
    var minutes_into_day = startTime.diff(startOfDay, "minutes").minutes;
    var hours_into_day = minutes_into_day / 60;
    return hourHeight * (hours_into_day - props.topHourOffset) + "rem";
  };

  var shift = props.shift;

  return (
    <div
      ref={shiftRef}
      className={props.read_only ? "shift read-only" : "shift"}
      style={{ height: shiftHeight(), marginTop: shiftTop() }}
    >
      <div className="shift--name">{shift.name}</div>
      <div className="shift--header">
        {(shift.start_time instanceof DateTime
          ? shift.start_time
          : DateTime.fromISO(shift.start_time)
        ).toFormat("t")}{" "}
        -{" "}
        {(shift.end_time instanceof DateTime
          ? shift.end_time
          : DateTime.fromISO(shift.end_time)
        ).toFormat("t")}
      </div>
      <div className="shift--member_count">
        {i18n.t("schedule.shifts.member_count")} {shift.members.length}/
        {shift.attendance_limit}
      </div>
      <ShowMembersButton
        shift={shift}
        memberTypeProperties={props.memberTypeProperties}
        onAddMember={handleAddMember}
      />
      <EditShiftButton
        shift={shift}
        event={props.event}
        memberTypeProperties={props.memberTypeProperties}
      />
      <CopyShiftButton event={props.event} shift={shift} />
    </div>
  );
};

export default Shift;
